<script>
	import { onMount } from 'svelte';
    import { cuenta } from './../../controlador/store.js';
    import UserController from "../../controlador/userController.svelte";
    import { replace } from 'svelte-spa-router';
    let nombre = "",titulo = "",matricula = "";
    let control;
    onMount(()=>{
        nombre = $cuenta.nombre;
        titulo = $cuenta.titulo;
        matricula = $cuenta.matricula;
    })
    async function guardar(){
        await control.actualizarCuenta(nombre,titulo,matricula,$cuenta.firma);
        replace('/cuenta');
    }
</script>
<UserController bind:this={control} />
<div class="container centro">
	<h2>Editar Datos</h2>
	<div class="fila">
	  <input type="text" bind:value={nombre} placeholder="Nombre">
	</div>
	<div class="fila">
	  <input bind:value={titulo} type="text" placeholder="Titulo">
	</div>
	<div class="fila">
	  <input bind:value={matricula} type="text" placeholder="Matricula">
	</div>
	<div class="fila">
	  <button on:click={guardar} class="boton"><i class="ph-floppy-disk"></i> Guardar</button>
	  <a class="boton" href="#/home"><i class="ph-x-circle"></i> Volver</a>
	</div>
  </div>
  
  <style>
	  h2{
		color: white;
		width: 100%;
		padding: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.centro{
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  justify-content: flex-start;
	}
	.fila{
	  width: 90%;
	  max-width: 380px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	}
	.cuerpo{
	  width: 90%;
	  max-width: 380px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	}
	input{
	  width: 90%;
	  max-width: 380px;
	  margin-bottom: 10px;
	  border: none;
	  outline: none;
	  border-radius: 10px;
	  height: 30px;
	  padding: 5px;
	}
	.boton{
	  margin: 10px;
	  background: transparent;
	  padding: 5px;
	  color: white;
	  font-size: 20px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  border: none;
	  outline: none;
	  cursor: pointer;
	}
	i{
	  margin-top: 5px;
	  font-size: 30px;
	}
  </style>